
import { Link } from 'react-router-dom';

export default function CTA() {
  return (
    <section className="relative h-[600px] w-full overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Panoramic%20view%20of%20Tokyo%20Bay%20waterfront%20area%20during%20sunset%20with%20modern%20residential%20buildings%20and%20urban%20skyline%2C%20wide%20angle%20composition%20showing%20sophisticated%20neighborhood%20and%20city%20lights%20beginning%20to%20glow%2C%20warm%20golden%20hour%20lighting%20creating%20inviting%20atmosphere%2C%20professional%20real%20estate%20photography&width=1920&height=800&seq=cta-001&orientation=landscape"
          alt="東京湾岸エリアの夕景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/70 via-slate-900/50 to-slate-900/70"></div>
      </div>

      {/* Content */}
      <div className="relative h-full max-w-7xl mx-auto px-8 flex flex-col justify-between py-20">
        {/* Top Left - Main Title */}
        <div>
          <h2 className="text-7xl font-bold text-white leading-tight">
            まずは無料相談から<br />
            はじめませんか
          </h2>
        </div>

        {/* Bottom Section */}
        <div className="flex items-end justify-between">
          {/* Bottom Left - Button */}
          <button
            className="inline-flex items-center gap-4 px-8 py-4 bg-white text-slate-900 rounded-full hover:bg-slate-100 transition-all group whitespace-nowrap cursor-pointer"
          >
            <span className="text-lg font-medium">無料相談予約</span>
            <div className="w-10 h-10 bg-slate-900 rounded-full flex items-center justify-center">
              <i className="ri-arrow-right-line text-white text-lg group-hover:translate-x-1 transition-transform"></i>
            </div>
          </button>

          {/* Bottom Right - Description */}
          <div className="text-right">
            <p className="text-white text-xl leading-relaxed font-light">
              経験豊富なスタッフが<br />
              あなたの理想の住まい探しをサポートします
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
